import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import checkMarkSrc from '@assets/images/check_mark.svg';

import { useEventTracking } from '@hooks';
import { forum_path, forum_post_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { ForumPost } from '@utils/backend-api/forumPosts';
import { isStandalonePollPost } from '@utils/backend-api/polls';

import ForumPostScreenshot, { useForumPostScreenshot } from '../ForumPostPage/ForumPostScreenshot';
import ShareModalContent from '../ShareModal/ShareModalContent';
import styles from './styles.module.scss';

export default function CreatedCommentSuccess({ forumPost }: { forumPost: ForumPost }) {
  const body = ReactHtmlParser(forumPost.comment.body);
  const isPollOnly = isStandalonePollPost(forumPost);
  const { onDownloadScreenshot, renderScreenshotContent } = useForumPostScreenshot(
    forumPost?.title
  );
  const { trackEvent } = useEventTracking();

  const handleViewPostClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.ViewMyPost }));
  };

  const handleBackToForumClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.BackToForum }));
  };

  return (
    <>
      {!isPollOnly && !!renderScreenshotContent && (
        <ForumPostScreenshot
          title={forumPost.title}
          body={body}
          renderScreenshotContent={renderScreenshotContent}
          length={forumPost.comment.body.length}
          poll={forumPost.poll}
          isPollOnly={isPollOnly}
        />
      )}
      <div className="forum-post-form">
        <ShareModalContent
          title="Success! Your post is published"
          subtitle="Share your post with others"
          forumPost={forumPost}
          iconSrc={checkMarkSrc}
          onDownloadScreenshot={onDownloadScreenshot}
          copyLinkOnly={isPollOnly}
        />
        <div className={styles.viewPostButtonContainer}>
          <Link
            to={forum_post_path(forumPost.id)}
            className={clsx(styles.submitButton, 'button button-red button-large')}
            onClickCapture={handleViewPostClick}
          >
            View my post
          </Link>
          <Link
            to={forum_path()}
            className={clsx(styles.submitButton, 'button button-secondary button-large')}
            onClickCapture={handleBackToForumClick}
          >
            Back to forum
          </Link>
        </div>
      </div>
    </>
  );
}
